import styled from 'styled-components'

export const DetailsItemContainer = styled.div`
  opacity: 0;
  transition: all 400ms;

  &.active {
    opacity: 1;
  }

  h2 {
    font-size: 48px;
    color: var(--grey);
    margin-bottom: 2rem;
  }

  p {
    font-size: 16px;
    line-height: 22px;
    color: var(--grey2);
  }

  a {
    display: flex;
    align-items: center;
    background-color: var(--blue16);
    color: var(--light);
    font-weight: 600 !important;
    padding: 1rem !important;

    &:hover {
      background-color: var(--blue12);
    }

    span:first-of-type {
      margin-right: 0.5rem;
    }
  }

  @media only screen and (max-width: 500px) {
    h2 {
      font-size: 32px;
    }

    a {
      width: 100%;
      max-width: 100%;
      justify-content: center;
    }
  }
`

export const DetailsItemMainTextContainer = styled.div`
  margin-bottom: 2rem;
`
